import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import OptOutCard from "../components/OptOutCard";
import { unsubscribeFromEmail } from "../api/optOutApi";

/**
 * Public email unsubscribe page, mirroring the backend path on this domain.
 *
 * Emails normally link straight at the API host (BACKEND_URL), which serves its own
 * page, and mail clients POST there for one-click unsubscribe. This page exists so a
 * link built against the clean CRM domain still works instead of opening a blank
 * single-page-app route.
 */
const EmailUnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const [state, setState] = useState("loading");
  const [result, setResult] = useState({ title: "", message: "" });
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;

    let active = true;
    unsubscribeFromEmail(token)
      .then((data) => {
        if (!active) return;
        if (data.status === "redirect") {
          // Backend couldn't answer in JSON; let it serve its own page instead.
          window.location.replace(data.url);
          return;
        }
        setResult({ title: data.title, message: data.message });
        setState(data.status === "ok" ? "done" : "error");
      })
      .catch(() => {
        if (!active) return;
        setResult({
          title: "Something went wrong",
          message:
            "We couldn't process your unsubscribe just now. Please try again in a " +
            "moment, or reply to any email from us and we'll remove you manually.",
        });
        setState("error");
      });

    return () => {
      active = false;
    };
  }, [token]);

  return (
    <OptOutCard
      state={state}
      title={state === "loading" ? "One moment" : result.title}
      message={state === "loading" ? "Processing your request..." : result.message}
    />
  );
};

export default EmailUnsubscribePage;
